import style from './AngleIcon.module.scss';

export const AngleIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden="true"
        className={style.icon}
    >
        <path stroke="currentColor" d="M17 15h-6l-1-1V8" />
    </svg>
);
